import React, { useEffect, useState } from 'react'
import { AppBar, Avatar, Box, Button, IconButton, Menu, MenuItem, Toolbar, Typography } from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import profile from "../../assets/icons/profile-image.svg";
import { useNavigate } from 'react-router';
import "../../styles/layout/navbar/_navbar.scss"
import { getAdminProfileDetails, updateAdminLanguage } from '../../services/admin-services/AdminprofileServices';
import { getCustomerProfileDetails, updateCustomerLanguage } from '../../services/customer-services/customerProfileService';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { baseURL, languageDetail } from '../../content/content';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from 'jwt-decode';
import { useCommonContext } from '../../context/common';

const NavbarComponent = ({
    handleDrawerToggle = () => { }
}) => {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();
    const [user, setUser] = useState({})
    const [anchorEl, setAnchorEl] = useState(null);
    const [customer, setCustomer] = useState({})
    const [anchorLanguageEl, setAnchorLanguageEl] = useState(null);
    const [selectedItem, setSelectedItem] = useState(languageDetail.options[0]); // Default to the first item
    const open = Boolean(anchorLanguageEl);
    const { setSelectedLanguage, setIsAdmin } = useCommonContext();

    useEffect(() => {
        const decodedToken = jwtDecode(
            JSON.parse(localStorage.getItem("authToken"))
        );
        if (decodedToken.isAdmin) {
            getAdminProfile();
        } else {
            getCustomerProfile();
        }
    }, []);

    // Handle opening the menu
    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Handle closing the menu
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const getAdminProfile = async () => {
        const response = await getAdminProfileDetails();

        if (response?.isSuccess && response?.superAdminProfile) {
            setUser({
                firstName: response?.superAdminProfile?.firstName, lastName: response?.superAdminProfile?.lastName,
                profileImage: response?.superAdminProfile?.profileImage,
            })
            setSelectedLanguage(response?.superAdminProfile?.language)
            const selectLanguage = response?.superAdminProfile?.language ? languageDetail.options.find(i => i.value === response?.superAdminProfile?.language) : languageDetail.options[0]
            setSelectedItem(selectLanguage)
        }
    };

    const getCustomerProfile = async () => {
        const response = await getCustomerProfileDetails();

        if (response?.isSuccess && response?.customerProfile) {
            setCustomer({
                firstName: response?.customerProfile?.firstName, lastName: response?.customerProfile?.lastName,
                profileImage: response?.customerProfile?.profileImage,
            })
            setSelectedLanguage(response?.customerProfile?.language)
            i18n.changeLanguage(response?.customerProfile?.language)
            const selectLanguage = response?.customerProfile?.language ? languageDetail.options.find(i => i.value === response?.customerProfile?.language) : languageDetail.options[0]
            setSelectedItem(selectLanguage)
        }
    };

    const handleLanguageClick = (event) => {
        setAnchorLanguageEl(event.currentTarget);
    };

    const handleLanguageClose = () => {
        setAnchorLanguageEl(null);
    };

    const handleLanguageSelect = (item) => {
        setSelectedItem(item);
        setAnchorLanguageEl(null);
        changeAdminLanguage({ language: item.value })
    };

    const handleLogout = () => {
        localStorage.removeItem("authToken");
        localStorage.removeItem("selectClientId");
        navigate("/signIn");
        setIsAdmin(false);
    }

    const changeAdminLanguage = async (payload) => {
        if (Object.values(user).length > 0) {
            const response = await updateAdminLanguage(payload);
            if (response?.isSuccess) {
                setSelectedLanguage(payload?.language)
                i18n.changeLanguage(payload?.language)
            }
        } else {
            const response = await updateCustomerLanguage(payload);
            if (response?.isSuccess) {
                setSelectedLanguage(payload?.language)
                 i18n.changeLanguage(payload?.language)
            }
        }
    };

    return (
        <AppBar className='navbar-data'
            position="sticky"
            sx={{
                top: 0,
                right: 0,
                backgroundColor: "red",
                width: {
                    sm: `calc(100% - 268px)`
                },
                background: '#fff',
            }}
        >
            <Toolbar sx={{ display: 'flex', justifyContent: { xs: 'space-between', sm: 'end' } }}>
                <IconButton
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ display: { xs: "contents", sm: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>

                <Typography component='div' sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', cursor: "pointer", gap: 1 }}>
                    <div>
                        <Button
                            variant="outlined"
                            onClick={handleLanguageClick}
                            sx={{ textTransform: "none", border: 'none', p: 0 }}
                        >
                            <Box display="flex" gap={1} alignItems="center">
                                <IconButton sx={{ margin: 0, pe: 0, "& .MuiAvatar-root": { height: '25px', width: '25px' } }}>
                                    <Avatar alt="profile" src={selectedItem.image} />
                                </IconButton>
                                <Typography className='navbar-font' sx={{ display: { xs: 'none', lg: 'flex' } }}>{selectedItem.label}</Typography>
                                <Typography sx={{ fontSize: '0.8rem', color: 'red', display: { xs: 'none', lg: 'flex' }, paddingTop: { xs: "8px", md: '0' } }}>
                                    <KeyboardArrowDownIcon sx={{ cursor: "pointer" }} />
                                </Typography>
                            </Box>
                        </Button>
                        <Menu
                            anchorEl={anchorLanguageEl}
                            open={open}
                            onClose={handleLanguageClose}
                        >
                            {languageDetail.options.map((item) => (
                                <MenuItem key={item.id} onClick={() => handleLanguageSelect(item)} sx={{ py: 0 }}>
                                    <Box display="flex" alignItems="center">
                                        <IconButton sx={{ margin: 0, pe: 0, "& .MuiAvatar-root": { height: '20px', width: '20px' } }}>
                                            <Avatar alt="profile" src={item.image} />
                                        </IconButton>
                                        <Typography className='navbar-font'>{item.label}</Typography>
                                    </Box>
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                    {/* </Box> */}
                    <Typography component='div' sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', cursor: "pointer", gap: 1 }} onClick={handleMenuClick}>
                        <IconButton>
                            <Avatar alt="profile" src={user?.profileImage
                                ? `${baseURL}/upload/profileImages/superAdmin/${user.profileImage}`
                                : customer?.profileImage ? `${baseURL}/upload/profileImages/customer/${customer.profileImage}`
                                    : profile} />
                        </IconButton>
                        <Typography sx={{ fontSize: '0.8rem', color: '#000', display: { xs: 'none', lg: 'flex' } }}>
                            <p className='navbar-font'>{t("common_text_welcome")}, <br /> {user?.firstName && user?.lastName
                                ? user?.firstName + " " + user?.lastName
                                : customer?.firstName && customer?.lastName ? customer?.firstName + " " + customer?.lastName
                                    : "Natalie Vasquez"} </p>
                        </Typography>
                        <Typography sx={{ fontSize: '0.8rem', color: 'red', display: { xs: 'none', lg: 'flex' }, paddingTop: { xs: "8px", md: '0' } }}>
                            <KeyboardArrowDownIcon sx={{ cursor: "pointer" }} />
                        </Typography>
                    </Typography>
                </Typography>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                >
                    <MenuItem className='navbar-font' onClick={() => navigate(Object.values(user).length > 0 ? '/profile' : '/settings/profile')}>{t('profile_settings')}</MenuItem>
                    <MenuItem className='navbar-font' onClick={handleLogout}>{t('logout')}</MenuItem>
                </Menu>
            </Toolbar>
        </AppBar >
    )
}

export default NavbarComponent